import { gql } from '@apollo/client';
export const FETCH_ALL_FEATURED_ADS = gql`
  query FetchAllFeaturedAd {
    fetchAllFeaturedAd {
        data {
            featuredAds {
                identifier
                name
                featured_type
                featured_order
                video
                created_at
                image
                upload_status
                updated_at
                id
                status
            }
        }
        error {
            message
            code
            field
        }
    }
}
`;